import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/CSEASH201mid21.pdf'
import cse from '../assets/CSEASH201end21.pdf'

export default function Ec() {
  return (
    <div>
       <Subject title="Engineering Chemistry(ASH201)" mid='Q. Paper'
    book1=" Fundamentals of Molecular Spectroscopy, by C. N. Banwell"
     book2="Organic Chemistry: Structure and Function by K. P. C. Volhardt and N. E. Schore, 5th Edition "
    book1Link="http://www.rnlkwc.ac.in/pdf/study-material/chemistry/Spectroscopy.pdf"
    book2Link="https://www.pdfdrive.com/download.pdf?id=187722746&h=9b2d8bccecb1f38de4d2c18afc7ba150&u=cache&ext=pdf"
     int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}